import { createBrowserRouter } from 'react-router-dom';

import { BaseLayout } from 'app/railways/pages/layouts/base';
import { NotFoundPage } from 'app/railways/pages/not-found';
import { router as railwaysRouter } from 'app/railways/router';
import { router as terminalsRouter } from 'app/terminals/router';

import { railwayAppRoute, terminalsAppRoute } from './routes';

export const appRoutes = [
  {
    path: railwayAppRoute.path,
    children: railwaysRouter,
  },
  {
    path: terminalsAppRoute.path,
    children: terminalsRouter,
  },

  {
    path: '*',
    element: (
      <BaseLayout header="Страница не найдена">
        <NotFoundPage />
      </BaseLayout>
    ),
  },
];

export const router = createBrowserRouter(appRoutes);
